<template>
  <div>
    <van-action-sheet v-model="thatShow" title="同意退款" @close="close">
      <div>
        <div :class="_['sheet-content']">
          <div>
            <span>商品金额：</span>
            <span>￥1982.00</span>
          </div>
          <div>
            <span>配送费：</span>
            <span>￥1982.00</span>
          </div>
          <div :class="_.isrefund">
            <span>是否退还配送费</span>
            <div>
              <van-radio-group v-model="radio" direction="horizontal">
                <van-radio name="1">是</van-radio>
                <van-radio name="2">否</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div>
            <span>实际退款金额：</span>
            <span>￥1982.00</span>
          </div>
        </div>
        <div :class="[_['sheet-bottom'], _._hairlineTop]">
          <van-button
            round
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            block
            >确定</van-button
          >
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      show: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        radio: 1,
        thatShow: true,
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    watch: {
      show(newValue) {
        this.thatShow = newValue
      },
    },
    methods: {
      close() {
        this.thatShow = false
        this.$emit('close')
      },
    },
  })
</script>

<style lang="scss" module>
  .sheet-content {
    padding: 0px 14px 40px 11px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    .isrefund {
      display: flex;
      justify-content: space-between;
    }
  }
  .sheet-bottom {
    width: (100%-24) px;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }
</style>
